import { Box, Button, Typography, TextField } from "@mui/material";
import { Asterisk, Trash, UserCircleMinus, X } from "phosphor-react";
import { fdelete } from "../../API/callsAPI";
import myTeamsPageStyles from "./MyTeamsPageStyles";
import { useState } from "react";

const DeleteTeamModal = ({
  handleClose,
  teamDetails,
  handleRefresh,
  setSnackValue,
}) => {
  const [teamName, setTeamName] = useState("");
  const classes = myTeamsPageStyles();
  const handleDeleteTeam = async () => {
    try {
      const res = await fdelete({ url: `project-space/${teamDetails?.id}/` });
      setSnackValue({
        isOpen: true,
        message: `SuccessFully Deleted`,
        isError: false,
      });
      handleRefresh();
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#1B1D28",
        borderRadius: "20px",
        width: "500px",
        padding: "24px",
        "& .MuiTypography-root": {
          fontFamily: "Poppins",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          gap: "24px",
          // textAlign: "center",
        }}
      >
        {/* Header with icon and title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Trash size={24} color="#D61F1F" />
          <Typography fontSize={24} fontWeight={500} sx={{ color: "white" }}>
            Delete Team
          </Typography>
        </Box>

        {/* Confirmation text */}
        <Typography
          sx={{
            fontSize: "14px",
            color: "#F9F9F9",
          }}
        >
          Are you certain you want to delete team{" "}
          <strong>{teamDetails?.name}</strong>?
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#D61F1F",
          }}
        >
          Deleting this team will also delete projects in this team space
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <span className={classes.inputLabel}>Enter Team Name to proceed</span>
          <Asterisk size={12} color="#FF0000" weight="fill" />
        </Box>
        <TextField
          value={teamName}
          onChange={(e) => setTeamName(e.target.value)}
          className={classes.cardContentInput2}
          fullWidth
          placeholder="Enter team name here"
        />

        {/* Action buttons */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "16px",
          }}
        >
          <Button
            onClick={handleClose}
            startIcon={<X size={18} />}
            sx={{
              backgroundColor: "transparent",
              color: "#fff",
              border: "2px solid #6C65D9",
              borderRadius: "12px",
              padding: "12px 24px",
              fontSize: "14px",
              textTransform: "none",
              minWidth: "150px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              "&:hover": {
                backgroundColor: "rgba(108, 101, 217, 0.1)",
              },
              "&:disabled": {
                backgroundColor: "gray",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteTeam}
            startIcon={<Trash size={18} />}
            sx={{
              backgroundColor: "#D61F1F",
              color: "#fff",
              borderRadius: "10px",
              padding: "12px 24px",
              fontSize: "14px",
              textTransform: "none",
              minWidth: "150px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              "&:hover": {
                backgroundColor: "#B91C1C",
              },
              "&:disabled": {
                backgroundColor: "#252A38",
                color: "#606479",
              },
            }}
            disabled={teamName !== teamDetails?.name}
          >
            Delete Team
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DeleteTeamModal;
